export default __webpack_public_path__ + "static/media/Aura-Egg__80.c5a73935.png";